module.exports = __webpack_public_path__ + "static/media/fisdom_icon_gold.6ebdf9c0.svg";